import { defineComponent, ref, onMounted } from 'vue'
import { getPersonList, deletePerson } from './api'

export default defineComponent({
  name: 'ManageView',
  setup() {
    console.log('ManageView组件初始化')
    
    const personList = ref([])
    const currentPage = ref(1)
    const totalPages = ref(1)
    const searchQuery = ref('')
    const pageSize = ref(10)
    const loading = ref(false)

    // 获取纪念人列表
    const fetchPersonList = async () => {
      console.log('开始获取纪念人列表数据')
      try {
        loading.value = true
        const params = {
          page: currentPage.value,
          page_size: pageSize.value,
          search: searchQuery.value
        }
        console.log('请求参数:', params)
        
        console.log('发送请求前...')
        const response = await getPersonList(params)
        console.log('获取到响应:', response)
        
        if (response.status === 403) {
          console.warn('权限检查失败')
          alert('权限不足，请确认是否为管理员账号')
          return
        }
        personList.value = response.data.data || []
        totalPages.value = response.data.total_pages || 1
        currentPage.value = response.data.page || 1
        console.log('数据更新完成', {
          listLength: personList.value.length,
          totalPages: totalPages.value,
          currentPage: currentPage.value
        })
      } catch (error) {
        console.error('获取纪念人列表失败，详细错误:', error)
        alert('获取纪念人列表失败，请稍后重试')
      } finally {
        loading.value = false
        console.log('请求结束，loading状态:', loading.value)
      }
    }

    // 处理页码变化
    const handlePageChange = (page) => {
      console.log('页码变化:', page)
      currentPage.value = page
      fetchPersonList()
    }

    // 处理搜索
    let searchTimer = null
    const handleSearch = () => {
      console.log('搜索输入:', searchQuery.value)
      if (searchTimer) {
        clearTimeout(searchTimer)
      }
      searchTimer = setTimeout(() => {
        currentPage.value = 1
        fetchPersonList()
      }, 300)
    }

    // 处理编辑
    const handleEdit = (person) => {
      console.log('编辑纪念人:', person)
      // TODO: 实现编辑功能
      alert('编辑功能开发中')
    }

    // 处理删除
    const handleDelete = async (person) => {
      console.log('删除纪念人:', person)
      if (confirm(`确定要删除纪念人 "${person.name}" 吗？`)) {
        try {
          loading.value = true
          await deletePerson(person.id)
          alert('删除成功')
          fetchPersonList() // 重新加载列表
        } catch (error) {
          console.error('删除纪念人失败:', error)
          alert('删除失败，请稍后重试')
        } finally {
          loading.value = false
        }
      }
    }

    onMounted(() => {
      console.log('组件挂载完成，开始获取数据')
      fetchPersonList()
    })

    return {
      personList,
      currentPage,
      totalPages,
      searchQuery,
      loading,
      handlePageChange,
      handleSearch,
      handleEdit,
      handleDelete
    }
  }
}) 